const nameof = <T>(name: keyof T) => name as string;

export default nameof;
